var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sign-page',{attrs:{"title-text":"个人工作历史记录","request":_vm.request,"column-list":_vm.columnList,"form-parms-add":_vm.formParmsAdd,"table-size":"large","tableActions":_vm.tableActions,"dealFormData":_vm.dealFormData,"form-parms-update":_vm.formParmsUpdate,"tableActionsFixed":true,"need-data-file":true},on:{"dataFileUpdate":_vm.dataFileUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }